import styled from 'styled-components';

const ImprintStyle = styled.section`
	--titleMarginTop: var(--sp13x);
	--contentBlockMarginBottom: var(--sp8x);
	--blockTitleMarginBottom: var(--sp4x);
	--itemWrapMarginTop: var(--sp18x);

	margin-top: var(--headerHeight);

	.title {
		text-align: center;
		margin-top: var(--titleMarginTop);
	}

	.items-wrap {
		margin-top: var(--itemWrapMarginTop);

		.content-block {
			margin-bottom: var(--contentBlockMarginBottom);

			&:last-child {
				margin-bottom: unset;
			}

			.block-title {
				margin-bottom: var(--blockTitleMarginBottom);
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeL}) {
		--titleMarginTop: var(--sp10x);
		--contentBlockMarginBottom: var(--sp6x);
		--blockTitleMarginBottom: var(--sp3x);
		--itemWrapMarginTop: var(--sp15x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeM}) {
		--titleMarginTop: var(--sp8x);
		--contentBlockMarginBottom: var(--sp6x);
		--blockTitleMarginBottom: var(--sp3x);
		--itemWrapMarginTop: var(--sp13x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeS}) {
		--titleMarginTop: var(--sp6x);
		--contentBlockMarginBottom: var(--sp5x);
		--blockTitleMarginBottom: var(--sp3x);
		--itemWrapMarginTop: var(--sp10x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeXS}) {
		--titleMarginTop: var(--sp6x);
		--contentBlockMarginBottom: var(--sp5x);
		--blockTitleMarginBottom: var(--sp3x);
		--itemWrapMarginTop: var(--sp10x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSize}) {
		--titleMarginTop: var(--sp5x);
		--contentBlockMarginBottom: var(--sp4x);
		--blockTitleMarginBottom: var(--sp3x);
		--itemWrapMarginTop: var(--sp5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSizeS}) {
		--titleMarginTop: var(--sp5x);
		--contentBlockMarginBottom: var(--sp4x);
		--blockTitleMarginBottom: var(--sp3x);
		--itemWrapMarginTop: var(--sp5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--titleMarginTop: var(--sp3x);
		--contentBlockMarginBottom: var(--sp3x);
		--blockTitleMarginBottom: var(--sp2x);
		--itemWrapMarginTop: var(--sp4x);
	}
`;

export default ImprintStyle;
